import { Routes, Route } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Dashboard } from './pages/Dashboard';
import { CopyEditor } from './pages/CopyEditor';
import { CustomOptimizer } from './pages/CustomOptimizer';
import { DeployLog } from './pages/DeployLog';
import { Settings } from './pages/Settings';
import { AdCreator } from './pages/AdCreator';
import { BatchCreator } from './pages/BatchCreator';
import { CopyHistory } from './pages/CopyHistory';
import { CopyPatternEfficiencyDashboard } from './pages/CopyPatternEfficiencyDashboard';
import { Login } from './pages/Login';
import { Layout } from './components/Layout';
import { SearchAdCreatorV2 } from './pages/v2/SearchAdCreatorV2';

const GOOGLE_CLIENT_ID = '1099048232723-3mkkju9csjc2vho5nb581hv5hseffklm.apps.googleusercontent.com';

export default function App() {
    return (
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
            <AuthProvider>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                        <Route index element={<Dashboard />} />
                        <Route path="editor/:id" element={<CopyEditor />} />
                        <Route path="optimizer" element={<CustomOptimizer />} />
                        <Route path="ad-creator" element={<AdCreator />} />
                        <Route path="v2/ad-creator" element={<SearchAdCreatorV2 />} />
                        <Route path="batch-creator" element={<BatchCreator />} />
                        <Route path="copy-history" element={<CopyHistory />} />
                        <Route path="copy-pattern-efficiency" element={<CopyPatternEfficiencyDashboard />} />
                        <Route path="history" element={<DeployLog />} />
                        <Route path="settings" element={<Settings />} />
                    </Route>
                </Routes>
            </AuthProvider>
        </GoogleOAuthProvider>
    );
}
